import styled from 'styled-components';

export const TableWrapperContainer = styled.div.attrs({})`
  width: 100%;
  background: ${(props) =>
    props.background
      ? props.theme.palette.colors.background
      : props.theme.palette.colors.white};
  padding: 24px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  /* Deixa o card encolher quando a tela acaba, em vez de empurrar a pagina.
     Quem absorve a sobra e a tabela, que rola por dentro. Sem flex: 1 de
     proposito — assim uma listagem curta continua do tamanho do conteudo, sem
     esticar o card e deixar vazio embaixo. */
  min-height: 0;
  overflow: hidden;
`;

export const TableWrapperHeader = styled.div.attrs({})`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
`;

export const TableWrapperButtonContainer = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  @media (max-width: 450px) {
    width: 100%;
  }
`;

export const TableHeaderTitleContainer = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px; /* Espaço entre os Cards e o Pesquisar */
  margin-left: auto; /* Força o agrupamento para a direita */
  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    margin-left: 0;
  }
`;

export const TableHeaderSubTitle = styled.div.attrs({})`
  font-family: Kumbh Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  text-align: left;
  margin-top: 16px;
  color: ${(props) => props.theme.palette.colors.black};
`;

export const ContainerOutlined = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  width: 300px;
  margin-left: 50px;
  @media (max-width: 450px) {
    width: 100%;
    min-width: 200px;
  }
`;

export const Link = styled.span.attrs({})`
  font-family: Kumbh Sans;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  text-align: left;
  text-decoration-line: underline;
  text-decoration-style: solid;
  cursor: pointer;
`;

// Itens do dropdown de botao com `options`: titulo em cima, explicacao curta
// embaixo, para o operador nao errar entre carteira e baixa.
export const MenuItemTexto = styled.div.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 4px 0;
`;

export const MenuItemTitulo = styled.span.attrs({})`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.theme.palette.colors.black};
`;

export const MenuItemDescricao = styled.span.attrs({})`
  font-size: 12px;
  color: #718096;
  white-space: normal;
  max-width: 260px;
`;

export const ButtonContent = styled.div.attrs({})`
  width: fit-content;
  @media (max-width: 450px) {
    width: 100%;
  }
`;
